<template>
  <f7-page class="main-inventory-regularization">
    <template #fixed>
      <TheNavbar
        :style="appTheme"
        :nav-title="$t('warehouse.info.countAndInventory')"
        back-btn-enable
        add-btn-enable
        @add-btn="PressOpenFilters"
      />
    </template>
    <!-- <pre> {{ mainData }}</pre> -->
    <div
      v-if="showNoExpeditions"
      class="content-no-expeditions"
    >
      <span class="content-no-expeditions__text padding-half"> {{ $t('common.pleasePress') }}
        <img
          class="content-no-expeditions__img"
          src="@/static/icons/base.svg"
          width="30"
        >
        {{ $t('warehouse.info.toStartANewRecount') }}
      </span>
    </div>
    <UCPreload :show="showPreload" />
    <f7-panel
      class="main-inventory-regularization-panel hide-popup-scanner"
      right
      resizable
      :opened="panelDerecho"
      @panel:closed="panelDerecho = false"
    >
      <f7-view>
        <f7-page>
          <div class="content-filters">
            <div class="content-filters__header padding-half">
              <div class="content-filters__header--title">
                <img src="@/static/icons/ic_filter.svg">{{ $t('common.initialParameters').toUpperCase() }}
              </div>
              <div class="content-filters__header--buttons">
                <img
                  class="margin-right-half"
                  src="@/static/icons/ic_info.svg"
                  width="28"
                  height="28"
                >
                <img
                  src="@/static/icons/ic_close_blue_2.svg"
                  width="28"
                  height="28"
                  @click="panelDerecho = false"
                >
              </div>
            </div>
            <div class="padding-horizontal-half margin-top-half">
              <UCDatePicker
                id="date-picker-form"
                :title="$t('common.date')"
                @onchange="ChangedDate"
              />
              <div class="content-filters__warehouse">
                <UCSearchEntityERP
                  ref="UCWarehouseComponent"
                  :title="$t('common.warehouse')"
                  :placeholder="$t('searchEntity.warehouse.placeholder.searchByOrigin')"
                  :search-text="$t('searchEntity.warehouse.searchText')"
                  :search-cancellation-text="$t('searchEntity.warehouse.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.warehouse.searchNotFoundText')"
                  :end-point-for-code-search="GetStoreByCode"
                  :end-point-for-list="GetStore"
                  :property-entity-shown-input="['Codigo', 'Nombre']"
                  :property-entity-shown-list-title="['Codigo']"
                  :property-entity-shown-list-subtitle="['Nombre']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventWarehouseSelected"
                />
              </div>
              <div class="content-filters__location">
                <UCSearchEntityERP
                  ref="UCLocations"
                  :title="$t('common.location')"
                  :placeholder="$t('searchEntity.location.placeholder.searchByLocation')"
                  :search-text="$t('searchEntity.location.searchText')"
                  :search-cancellation-text="$t('searchEntity.location.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.location.searchNotFoundText')"
                  :end-point-for-code-search="GetLocationsByCode"
                  :end-point-for-list="GetLocations"
                  :property-entity-shown-input="['Codigo', 'Nombre']"
                  :property-entity-shown-list-title="['Codigo']"
                  :property-entity-shown-list-subtitle="['Nombre']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  :qr-search-show="true"
                  :qr-search-params="{
                    showInputButton: true,
                    fabButtonShow: false,
                    allowManualCodeEntry: true,
                    autoOpenCamera: false,
                    autofocusOnInput: true,
                  }"
                  @qr-open-search="EventQrOpen"
                  @selection="EventLocationSelected"
                />
              </div>
              <div class="content-filters__families">
                <UCSearchEntityERP
                  ref="UCFamiliaArticulo"
                  :title="$t('searchEntity.articleFamily.title.optionalArticleFamily')"
                  :placeholder="$t('searchEntity.articleFamily.placeholder.selectAFamily')"
                  :search-text="$t('searchEntity.articleFamily.searchText')"
                  :search-cancellation-text="$t('searchEntity.articleFamily.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.articleFamily.searchNotFoundText')"
                  :end-point-for-code-search="GetArticlesFamiliesByCode"
                  :end-point-for-list="GetArticlesFamilies"
                  :property-entity-shown-input="['Codigo', 'Nombre']"
                  :property-entity-shown-list-title="['Codigo']"
                  :property-entity-shown-list-subtitle="['Nombre']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventFamiliaArticulosSelected"
                />
              </div>
              <div class="content-filters__articles">
                <UCSearchEntityERP
                  ref="UCArticlesComponent"
                  :title="$t('searchEntity.article.title.optionalArticle')"
                  :placeholder="$t('searchEntity.article.placeholder.searchByArticles')"
                  :search-text="$t('searchEntity.article.searchText')"
                  :search-cancellation-text="$t('searchEntity.article.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.article.searchNotFoundText')"
                  :end-point-for-list="GetArticles"
                  :end-point-for-code-search="GetArticlesByCode"
                  :property-entity-shown-input="['Codigo', 'Nombre']"
                  :property-entity-shown-list-title="['Codigo']"
                  :property-entity-shown-list-subtitle="['Nombre']"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  :disabled="ubicacion == null"
                  :qr-search-show="true"
                  :qr-search-params="{
                    showInputButton: true,
                    fabButtonShow: false,
                    allowManualCodeEntry: true,
                    autoOpenCamera: false,
                    autofocusOnInput: true,
                  }"
                  :dont-qr-select="true"
                  @qr-value="EventBarcodeArticlesSelected"
                  @qr-open-search="EventQrOpen"
                  @selection="EventArticlesSelected"
                />
              </div>
              <div class="content-filters__logistic-unit">
                <UCSearchEntityERP
                  ref="UCLogisticUnitComponent"
                  placeholder="Buscar por unidad logística"
                  title="Unidad Logística (Opcional)"
                  search-text="Buscando unidades logísticas..."
                  search-cancellation-text="Busqueda de unidades logísticas cancelada..."
                  search-not-found-text="Unidad logística no encontrada.."
                  :end-point-for-list="GetLogisticUnit"
                  :end-point-for-code-search="GetLogisticUnit"
                  :property-entity-shown-input="['NumeroSerie']"
                  :property-entity-shown-list-title="['NumeroSerie']"
                  :property-entity-shown-list-subtitle="['NumeroSerie']"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  :qr-search-show="true"
                  :qr-search-params="{
                    showInputButton: true,
                    fabButtonShow: false,
                    allowManualCodeEntry: true,
                    autoOpenCamera: false,
                    autofocusOnInput: true,
                  }"
                  :dont-qr-select="true"
                  @qr-open-search="EventQrOpen"
                  @selection="EventLogisticUnitSelected"
                  @qr-value="EventLogisticUnitSelected"
                />
              </div>
              <div class="content-filters__buttons">
                <img
                  src="@/static/icons/ic_reset.svg"
                  height="31"
                  width="31"
                >
                <f7-button
                  class="content-filters__buttons--search"
                  @click="FilterComplete()"
                >
                  {{ $t('common.start') }}
                </f7-button>
              </div>
            </div>
          </div>
        </f7-page>
      </f7-view>
    </f7-panel>
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';

import TheNavbar from '@/components/TheNavbar.vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { callExecuteSPERP, callFetchWarehousesForEnterpriseGroupsAndLocations } from '@/js/services/APIErp';
import UCPreload from '@/components/common/UCPreload.vue';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmInventoryRegularizationHome',
  components: {
    TheNavbar,
    UCDatePicker,
    UCSearchEntityERP,
    UCPreload,
  },
  data() {
    return {
      showNoExpeditions: true,
      panelDerecho: false,
      familiaArticulo: null,
      articulo: null,
      ubicacion: null,
      fecha: new Date(),
      almacen: null,
      unidadLogistica: null,
      mainData: null,
      cumulative: [],
      showPreload: false,
      qrOpen: false,
    };
  },

  computed: {
    ...mapState(useAppConfigStore, ['userEnviroment']),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },
  },
  mounted() {
    this.StartComponent();
  },
  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.GetDefaultWarehouse();
    },
    PressOpenFilters() {
      Log(this, this.PressOpenFilters.name);
      this.panelDerecho = true;
    },
    async FilterComplete() {
      Log(this, this.FilterComplete.name);
      if (this.almacen === null || this.ubicacion === null) {
        HiNotification.Toast(this.$t('warehouse.info.completeAllRequiredFields'));
        return;
      }

      const filter = {
        location: this.ubicacion,
        articleFamily: this.familiaArticulo,
        article: this.articulo,
        warehouse: this.almacen,
        logisticUnit: this.unidadLogistica,
        date: new Date(this.fecha).toJSON(),
      };

      await this.GetMainData(filter);

      if (this.mainData !== null) {
        this.panelDerecho = false;
        f7.views.main.router.navigate('/warehouse/inventoryRegularization/frmInventoryRegularizationAndCount', {
          props: {
            mainData: this.mainData,
            filtro: filter,
            acumulado: this.cumulative,
          },
        });
      }
    },

    ChangedDate(date) {
      Log(this, this.ChangedDate.name);
      this.fecha = date;
    },

    EventLocationSelected(obj) {
      Log(this, this.EventLocationSelected.name);
      this.ubicacion = obj;
      if (this.almacen === null && obj !== null) {
        callFetchWarehousesForEnterpriseGroupsAndLocations({
          enterpriseGroupIds: [this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id],
          locationIds: [this.ubicacion.Id],
        }).then((result) => {
          if (result.status !== 200) {
            return;
          }
          this.$refs.UCWarehouseComponent.SelectEntity(result.data[0], true);
        });
      }
    },
    EventFamiliaArticulosSelected(obj) {
      Log(this, this.EventFamiliaArticulosSelected.name);
      this.familiaArticulo = obj;
      if (obj === null) {
        this.$refs.UCArticlesComponent.Clear({
          autoFocus: false,
          noEmitEvent: true,
        });
      }
    },
    EventArticlesSelected(obj) {
      Log(this, this.EventArticlesSelected.name);
      this.articulo = obj;
      if (this.familiaArticulo === null && obj !== null) {
        callExecuteSPERP(
          'APPERPAGRO_FamiliasArticuloXIdGrupoEmpresarialXArticulo',
          [
            { NombreParametro: 'filtro', Valor: '' },
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
            { NombreParametro: 'idsArticulo', Valor: this.articulo.Id },
          ],
          'Comun.FamiliaArticuloJSON',
        ).then((result) => {
          if (result.status !== 200) {
            return;
          }
          this.$refs.UCFamiliaArticulo.SelectEntity(result.data[0], true);
        });
      }
    },
    EventBarcodeArticlesSelected(code) {
      Log(this, this.EventBarcodeArticlesSelected.name);
      callExecuteSPERP(
        'APPERPAGRO_ArticuloXIdGrupoEmpresarialXUbicacion',
        [
          { NombreParametro: 'filtro', Valor: `barcode:${code}` },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsUbicacion', Valor: '' },
        ],
        'Comun.ArticuloJSON',
      ).then((result) => {
        if (result.status !== 200) {
          return;
        }
        this.familiaArticulo = null;
        if (result.data.length > 0) {
          this.$refs.UCArticlesComponent.SelectEntity(result.data[0], true);
        }
      });
    },
    EventWarehouseSelected(obj) {
      Log(this, this.EventWarehouseSelected.name);
      this.almacen = obj;
      if (obj === null) {
        this.$refs.UCLocations.Clear({
          autoFocus: false,
          noEmitEvent: true,
        });
      }
    },
    async EventLogisticUnitSelected(obj) {
      Log(this, this.EventLogisticUnitSelected.name);
      if (!obj) {
        this.unidadLogistica = null;
        this.$refs.UCLocations?.Clear();
        this.$refs.UCWarehouseComponent?.Clear();
        return;
      }

      try {
        this.$refs.UCWarehouseComponent.Clear();

        let unidadLogistica;

        if (this.qrOpen) {
          const result = await this.GetLogisticUnit(obj);
          if (result.data.length > 0) {
            [unidadLogistica] = result.data;
            this.$refs.UCLogisticUnitComponent.SelectEntity(unidadLogistica, true);
            this.$refs.UCLocations.SelectEntity(unidadLogistica.Ubicacion, true);
          }
        } else {
          unidadLogistica = obj;
          this.$refs.UCLocations.SelectEntity(unidadLogistica.Ubicacion, true);
        }

        this.unidadLogistica = unidadLogistica;
      } catch (error) {
        HiNotification.Toast(error);
      }
    },

    EventQrOpen(val) {
      Log(this, this.EventQrOpen.name);
      this.qrOpen = val;
    },

    /* almacenes */
    GetStore() {
      Log(this, this.GetStore.name);
      return callFetchWarehousesForEnterpriseGroupsAndLocations({
        enterpriseGroupIds: [this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id],
      });
    },
    GetStoreByCode(params) {
      Log(this, this.GetStoreByCode.name);
      return callFetchWarehousesForEnterpriseGroupsAndLocations({
        filter: `q:${params}`,
        enterpriseGroupIds: [this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id],
      });
    },
    /* familia articulos */
    GetArticlesFamilies() {
      Log(this, this.GetArticlesFamilies.name);
      return callExecuteSPERP(
        'APPERPAGRO_FamiliasArticuloXIdGrupoEmpresarialXArticulo',
        [
          { NombreParametro: 'filtro', Valor: '' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsArticulo', Valor: '' },
        ],
        'Comun.FamiliaArticuloJSON',
      );
    },
    GetArticlesFamiliesByCode(params) {
      Log(this, this.GetArticlesFamiliesByCode.name);
      return callExecuteSPERP(
        'APPERPAGRO_FamiliasArticuloXIdGrupoEmpresarialXArticulo',
        [
          { NombreParametro: 'filtro', Valor: `q:${params}` },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsArticulo', Valor: '' },
        ],
        'Comun.FamiliaArticuloJSON',
      );
    },
    /* articulos */
    GetArticles() {
      Log(this, this.GetArticles.name);
      if (this.familiaArticulo !== null) {
        return callExecuteSPERP(
          'APPERPAGRO_ArticuloXIdGrupoEmpresarialXFamiliarArticulo',
          [
            { NombreParametro: 'filtro', Valor: '' },
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
            { NombreParametro: 'idsFamiliarArticulo', Valor: this.familiaArticulo.Id },
          ],
          'Comun.ArticuloJSON',
        );
      }
      return callExecuteSPERP(
        'APPERPAGRO_ArticuloXIdGrupoEmpresarialXUbicacion',
        [
          { NombreParametro: 'filtro', Valor: '' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsUbicacion', Valor: '' },
        ],
        'Comun.ArticuloJSON',
      );
    },
    GetArticlesByCode(params) {
      Log(this, this.GetArticlesByCode.name);
      if (this.qrOpen) {
        this.qrOpen = false;
        if (this.familiaArticulo !== null) {
          return callExecuteSPERP(
            'APPERPAGRO_ArticuloXIdGrupoEmpresarialXFamiliarArticulo',
            [
              { NombreParametro: 'filtro', Valor: `barcode:${params}` },
              { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
              { NombreParametro: 'idsFamiliarArticulo', Valor: this.familiaArticulo.Id },
            ],
            'Comun.ArticuloJSON',
          );
        }
        return callExecuteSPERP(
          'APPERPAGRO_ArticuloXIdGrupoEmpresarialXUbicacion',
          [
            { NombreParametro: 'filtro', Valor: `barcode:${params}` },
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
            { NombreParametro: 'idsUbicacion', Valor: '' },
          ],
          'Comun.ArticuloJSON',
        );
      }

      if (this.familiaArticulo !== null) {
        return callExecuteSPERP(
          'APPERPAGRO_ArticuloXIdGrupoEmpresarialXFamiliarArticulo',
          [
            { NombreParametro: 'filtro', Valor: `q:${params}` },
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
            { NombreParametro: 'idsFamiliarArticulo', Valor: this.familiaArticulo.Id },
          ],
          'Comun.ArticuloJSON',
        );
      }
      return callExecuteSPERP(
        'APPERPAGRO_ArticuloXIdGrupoEmpresarialXUbicacion',
        [
          { NombreParametro: 'filtro', Valor: `q:${params}` },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsUbicacion', Valor: '' },
        ],
        'Comun.ArticuloJSON',
      );
    },

    /* unidad logistica */
    GetLogisticUnit(code) {
      Log(this, this.GetLogisticUnit.name);
      if (this.qrOpen) {
        this.qrOpen = false;
        return callExecuteSPERP(
          'APPERPAGRO_ArticulosNumeroSerieRecuentoExistencias',
          [
            { NombreParametro: 'filtro', Valor: `barcode:${code === undefined ? '' : code}` }, // Id, barcode, numeroserie
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          ],
          'Almacen.UnidadContenedoraJSON',
        );
      }

      return callExecuteSPERP(
        'APPERPAGRO_ArticulosNumeroSerieRecuentoExistencias',
        [
          { NombreParametro: 'filtro', Valor: `numeroserie:${code === undefined ? '' : code}` }, // Id, barcode, numeroserie
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
        ],
        'Almacen.UnidadContenedoraJSON',
      );
    },

    /* Ubicaciones */
    GetLocationsByCode(params) {
      Log(this, this.GetLocationsByCode.name);
      let idAlmacen = '';
      if (this.almacen != null) {
        idAlmacen = this.almacen.Id;
      }

      if (this.qrOpen) {
        this.qrOpen = false;
        return callExecuteSPERP(
          'APPERPAGRO_UbicacionesXIdGrupoEmpresarialXAlmacen',
          [
            { NombreParametro: 'filtro', Valor: `barcode:${params}` },
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
            { NombreParametro: 'idsAlmacen', Valor: idAlmacen },
          ],
          'Almacen.UbicacionJSON',
        );
      }
      return callExecuteSPERP(
        'APPERPAGRO_UbicacionesXIdGrupoEmpresarialXAlmacen',
        [
          { NombreParametro: 'filtro', Valor: `q:${params}` },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsAlmacen', Valor: idAlmacen },
        ],
        'Almacen.UbicacionJSON',
      );
    },
    GetLocations() {
      Log(this, this.GetLocations.name);
      let idAlmacen = '';
      if (this.almacen != null) {
        idAlmacen = this.almacen.Id;
      }
      return callExecuteSPERP(
        'APPERPAGRO_UbicacionesXIdGrupoEmpresarialXAlmacen',
        [
          { NombreParametro: 'filtro', Valor: '' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsAlmacen', Valor: idAlmacen },
        ],
        'Almacen.UbicacionJSON',
      );
    },
    GetDefaultWarehouse() {
      Log(this, this.GetDefaultWarehouse.name);
      if (this.userEnviroment != null && this.userEnviroment.EntornoDeTrabajo !== null) {
        callFetchWarehousesForEnterpriseGroupsAndLocations({
          filter: `id:${this.userEnviroment.EntornoDeTrabajo.Almacen?.Id}`,
          enterpriseGroupIds: [this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id],
        }).then((result) => {
          if (result.status !== 200) {
            return;
          }
          this.$refs.UCWarehouseComponent.SelectEntity(result.data[0], true);
        });
      }
    },

    async GetMainData(filtro) {
      Log(this, this.GetMainData.name);
      await this.GetStockCount(filtro);
      await this.GetCumulativeStock(filtro);
    },

    async GetStockCount(filtro) {
      Log(this, this.GetStockCount.name);

      HiDialog.Preloader(true, this.$t('warehouse.info.loadingCountAndInventory'), false);
      const date = HiDateTimeSupport.FormatDateTime(
        new Date(filtro.date),
        'YYYY-MM-DD',
      );
      try {
        let result = null;
        result = await callExecuteSPERP(
          'APPERPAGRO_RecuentoExistencias',
          [
            { NombreParametro: 'FechaRecuento', Valor: date },
            { NombreParametro: 'IdArticulo', Valor: filtro.article !== null ? filtro.article.Id : 0 },
            { NombreParametro: 'IdAlmacen', Valor: filtro.warehouse !== null ? filtro.warehouse.Id : 0 },
            { NombreParametro: 'Ubicacion', Valor: filtro.location !== null ? filtro.location.Id : 0 },
            { NombreParametro: 'FamiliaArticulo', Valor: filtro.articleFamily !== null ? filtro.articleFamily.Id : 0 },
            { NombreParametro: 'IdUnidadLogistica', Valor: filtro.logisticUnit !== null ? filtro.logisticUnit.Id : 0 },
          ],
          'Almacen.RecuentoExistenciaJSON',
        );

        if (result.statusText === 'OK' || result.status === 200) {
          this.mainData = result.data;
          HiDialog.Preloader(false);
          return null;
        }
        HiDialog.Preloader(false);
        HiNotification.Toast(this.$t('warehouse.info.noCountFoundWithTheseFilters'));
        return null;
      } catch (error) {
        LogError(this, this.GetMainData.name, error);
        HiDialog.Preloader(false);
        HiNotification.Toast(this.$t('warehouse.info.noCountFoundWithTheseFilters'));
        this.showPreload = false;
        return null;
      }
    },

    async GetCumulativeStock(filtro) {
      const date = HiDateTimeSupport.FormatDateTime(
        new Date(filtro.date),
        'DD/MM/YYYY',
      );
      this.cumulative = [];
      HiDialog.Preloader(true, this.$t('warehouse.info.loadingCountAndInventory'), false);
      const fecha = date;
      const articulo = filtro.article != null ? filtro.article.Id : 0;
      const almacen = filtro.warehouse !== null ? filtro.warehouse.Id : null;
      const ubicacion = filtro.location !== null ? filtro.location.Id : null;
      const familia = filtro.articleFamily !== null ? filtro.articleFamily.Id : null;
      const unidadLogistica = filtro.logisticUnit !== null ? filtro.logisticUnit.Id : null;

      try {
        let result = null;
        result = await callExecuteSPERP(
          'APPERPAGRO_ExistenciasAFechaParaRecuento',
          [
            { NombreParametro: 'fecha', Valor: fecha },
            { NombreParametro: 'IdArticulo', Valor: articulo },
            { NombreParametro: 'IdAlmacen', Valor: almacen },
            { NombreParametro: 'Ubicacion', Valor: ubicacion },
            { NombreParametro: 'FamiliaArticulo', Valor: familia },
            { NombreParametro: 'IdUnidadLogistica', Valor: unidadLogistica },
            { NombreParametro: 'IdCentro', Valor: this.userEnviroment.EntornoDeTrabajo.Centro.Id },
          ],
          'Almacen.AcumuladoExistenciasJSON',
        );

        if (result.statusText === 'OK' || result.status === 200) {
          this.cumulative = result.data;
          this.cumulative.forEach((e) => {
            e.Regularizado = null;
          });

          HiDialog.Preloader(false);
          return null;
        }

        HiDialog.Preloader(false);
        return null;
      } catch (error) {
        LogError(this, this.GetCumulativeStock.name, error);
        this.cumulative = null;
        HiDialog.Preloader(false);
        HiNotification.Toast(this.$t('warehouse.info.noCountFoundWithTheseFilters'));
        this.showPreload = false;
        return null;
      }
    },

  },
};
</script>

<style lang="scss">
.main-inventory-regularization {
  .disabled-component {
    opacity: 0.6;
    pointer-events: none;
  }

  .content-no-expeditions {
    height: calc(100vh - var(--f7-page-navbar-offset) - var(--information-bar-height));
    display: flex;
    justify-content: center;
    align-items: center;

    &__text {
      font-style: normal;
      text-align: center;
      font-weight: 400;
      font-size: 26px;
      line-height: 35px;
      color: #aaa1a1;
    }
  }
}

.main-inventory-regularization-panel {
  .content-filters {
    --f7-block-padding-horizontal: 0px;
    --f7-block-title-margin-bottom: 2px;
    --f7-block-title-text-color: var(--his-slate-blue);

    --search-input-height: 36px;
    --search-input-color: #848192;
    --search-font-size: 14px;
    --search-font-weight: 400;
    --search-btn-min-width: 40px;
    --date-picker-input-height: var(--search-input-height);
    --date-picker-input-color: var(--search-input-color);
    --date-picker-font-size: var(-search-font-size);
    --date-picker-font-weight: var(--search-font-weight);
    --date-picker-btn-min-width: var(--search-btn-min-width);

    display: flex;
    flex-direction: column;
    background-color: #f6f6f6;

    &__location,
    &__articles {
      display: flex;
      flex-direction: row;

      &--img {
        width: 32px;
        padding-left: 5px;
        margin-top: 6px;
      }
    }

    span {
      color: var(--his-slate-blue);
      font-size: 13px;
      // padding-left: 13px;
    }

    .content-searcher-erp {
      margin-bottom: 13px;

      .div-qr-search {
        border: none;
        margin-left: 5px;
        padding-bottom: 0;
        padding-left: 0;
        padding-right: 0;

        img {
          content: url("@/static/icons/ic_qr.svg");
        }
      }
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid var(--his-silver);

      &--title {
        display: flex;
        justify-content: flex-start;
        color: var(--his-steel-blue);
        font-size: 13px;
        text-transform: uppercase;
        font-weight: 500;

        img {
          padding-right: 5px;
        }
      }

      &--buttons {
        height: 28px;
      }
    }

    &__buttons {
      display: flex;
      align-items: center;

      img {
        margin-right: 5px;
      }

      &--search {
        background-color: var(--his-oliva);
        color: #fff;
        width: 100%;
        height: 32px;
      }
    }

    .date-picker {
      margin-bottom: 20px;

      .block-title {
        margin-left: 8px;
      }
    }
  }
}
</style>
